import {TrainingProductOriginDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createTrainingProductOrigin(
    userData: Record<string, string>,
    trainingProductOrigin: Record<string, any>
) {
    try {
        const result = await TrainingProductOriginDao.createTrainingProductOrigin(userData.userToken, trainingProductOrigin);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
